<template>
    <div v-if="show">
        <d-contract-history
            v-model  = "history.show"
            :unit    = "history.unit"
            :history = "history.data"
            :contract= "contract"
        />

        <c-card-iterator
            :items          = "filteredUnits"
            :label          = "fullTitle"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "itemHeight"
            :total-visible  = "5"
            :filter-height  = "235"
            :filter         = "match"
            :zoom           = "false"
            :left-arrow     = "false"
            :header-color   = "headerColor"
            ref             ="iterator"
        >
            <template v-slot:toolbar>
                <c-toolbar-button
                    v-if    = "allowNew"
                    class   = "mr-3"
                    style   = "margin-top: -2px;"
                    icon    = "mdi-plus"
                    size    = "22"
                    color   = "white"
                    tooltip = "Neue Anlage"
                    @click  = "onNewUnit"
                />
                <c-toolbar-button
                    v-if    = "allowBulkEdit && isDataAdmin"
                    class   = "mr-3"
                    style   = "margin-top: -2px;"
                    icon    = "mdi-pencil-box-multiple-outline"
                    size    = "22"
                    color   = "white"
                    tooltip = "Bulk Edit"
                    @click  = "onBulkEdit"
                />


            </template>
            <template v-slot:card="{ item }">
                <c-site-card
                    :site        = "item"
                    :selected    = "item.checked"
                    :selectable  = "isSelectable"
                    :height      = "itemHeight"
                    @click       = "onEdit"
                    @site        = "onSite"
                    @assign      = "onAssign"
                    @deselect    = "onDissolve"
                >
                    <template v-slot:editor="{ site }" >
                        <div v-if="isAssignedToContract(site)">
                            <slot name="editor" v-bind:site="site"></slot>
                        </div>
                    </template>
                    <template v-slot:toolbar>
                        <c-toolbar-button
                            style   = "margin-left: 8px; margin-top: -2px"
                            v-if    = "contract"
                            size    = "22"
                            color   = "primary"
                            icon    = "mdi-history"
                            tooltip = "Historie zum Vertrag"
                            @click  = "onContractHistory(item, contract.type.id)"
                        />
                    </template>
                </c-site-card>
            </template>
            <template v-slot:filter >
                <div>
                    <v-row class="no-frame">
                        <v-col class="no-frame v-flex">
                            <v-checkbox
                                label   = "Anlagen im Liftmanagement"
                                v-model = "filter.active"
                                class   = "mt-0"
                                :ripple = "false"
                                hide-details
                                @change = "onFilterChanged"
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="orphan">
                        <v-col class="no-frame v-flex">
                            <v-checkbox
                                label   = "Liftmanagement Vertrag wird beendet"
                                v-model = "filter.terminate"
                                class   = "mt-0"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="orphan">
                        <v-col class="no-frame v-flex">
                            <v-checkbox
                                label   = "Anlagen ohne Liftmanagement"
                                v-model = "filter.orphan"
                                class   = "mt-0"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame v-flex">
                            <v-checkbox
                                label   = "stillgelegte / inaktive Anlagen"
                                v-model = "filter.inactive"
                                class   = "mt-0"
                                :ripple = "false"
                                @change = "onFilterChanged"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-divider class="mt-2 mb-1" />

                    <v-row class="no-frame" v-if="orphan">
                        <v-col class="no-frame v-flex">
                            <v-select
                                v-model = "companyFilter"
                                label   = "Serviceunternehmen"
                                :items  = "companies"
                                @change = "onFilter"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                </div>
            </template>
            <template v-slot:prefix>
                <div class="ml-n2" style="margin-top: -2px">
                    <c-toolbar-button
                        v-if  = "isAssignModePossible  && customer"
                        size  = "22"
                        color = "white"
                        icon   = "mdi-plus-circle"
                        @click = "onStartAssingMode"
                    />
                    <c-toolbar-button
                        v-if  = "isItemSelected && assignUnitMode && customer"
                        size  = "22"
                        color = "white"
                        icon  = "mdi-arrow-left-circle"
                        @click = "onEndAssingMode"
                    />
                </div>
            </template>
        </c-card-iterator>
    </div>
</template>

<script>

import Site           from "@/modules/msd/unit/service/Site";
import CSiteCard      from "@/modules/msd/unit/components/controlls/CSiteCard";
import CCardIterator  from "@/modules/core/components/utils/CCardIterator";
import Contact        from "@/modules/msd/company/contact/service/Contact";
import Contract       from "@/modules/msd/company/contract/service/Contract";
import Core           from "@/modules/core/service/Core";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";
import company from "@/modules/msd/company/common/service/Company";
import DContractHistory from "@/modules/msd/company/contract/components/controls/DContractHistory.vue";

const ALL_COMPANIES = "alle";

export default {
    name: "CSiteCardIterator",

    components: {
        DContractHistory,
        CToolbarButton,
        CCardIterator,
        CSiteCard,
    },

    props: {
        role: {
            required: true,
            type    : String,
            default : function () {
                return null;
            }
        },

        contract: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        contact: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        customer: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        title: {
            required: false,
            type    : String,
            default : function () {
                return "Anlagen";
            }
        },

        orphan: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        paddingRight: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        headerColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },

        contractHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },
        visibleContracts: {
            required: false,
            type    : Array,
            default : function () {
                return null;
            }
        },
        allowNew: {
            default: function () {
                return false;
            }
        },

        allowBulkEdit: {
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        history: {
            unit: null,
            show: false,
            data: null,
        },

        page: 1,
        loading   : false,
        sites     : null,
        filteredUnits: null,
        contactUnits: [],
        searchtext: "",
        count     : null,
        selected  : null,
        edit      : null,
        companies : [],
        companyFilter: null,
        filter: {
            contract: null,
            contact : null,
            customer: null,
            active  : true,
            inactive: false,
            terminate: false,
            orphan  : true,
        }
    }),

    mounted() {
        this.load();
    },

    watch: {
        customer () {
            this.load();
        },

        contract () {
            if (!this.sites) {
                return;
            }

            this.sites.forEach(site => {
                site.checked = false;
            });

            if (this.contract) {
                this.sites.forEach(site => {
                    site.checked = this.isSelected(site);
                })
            }

            this.onFilter();
        },

        contact () {
            this.sites.forEach(site => {
                site.checked = false;
            });

            if (!this.customer) {
                this.filter.customer = null;
            } else {
                this.filter.customer = this.customer.id;
            }

            this.loadContactAssignments ();
        },

        visibleContracts () {
            // Re-filter sites when visible contracts change
            this.onFilter();
        }
   },

    computed: {
        show () {
            return true;
        },

        isDataAdmin () {
            return Core.security.isDataAdmin();
        },

        isSelectable () {
            if (this.contact && (Contact.isGlobal(this.contact) || Contact.isGlobalCustomer(this.contact))) {
                return false;
            }

            return this.isItemSelected;
        },

        isItemSelected () {
            return this.contract != null ||this.contact != null;
        },

        isAssignModePossible () {
            if (this.contact && (Contact.isGlobal(this.contact) || Contact.isGlobalCustomer(this.contact))) {
                return false;
            }

            return this.isItemSelected && !this.assignUnitMode;
        },

        fullTitle () {
            if (this.filter.contract) {
                return this.title + " zum Vertrag"
            }

            if (!this.customer && this.contact) {
                return this.title + " - " + this.contact.name
            }
            return this.title + " - " + (this.customer ? this.customer.name : "Bitte Kunden auswählen");
        },

        itemHeight () {
            return this.contract ? 150 + this.contractHeight : 150;
        },

        assignUnitMode () {
            return this.$store.getters.assignUnitMode;
        },
    },

    methods: {
        company() {
            return company
        },

        update (unit) {
            const index = this.sites.findIndex (u => u.id === unit.id);
            if (index >= 0) {
                Site.unit(unit.id).then(unit => {
                    this.sites[index] = unit;
                    this.onFilter();
                })
            }
        },

        load (callback) {
            this.$store.dispatch("setAssignUnitMode", false);
            if (!this.customer && !this.contact) {
                this.sites = [];
                this.onFilter();
                return;
            }

            this.filter.customer = this.customer ? this.customer.id : null;
            this.filter.contact  = this.contact  ? this.contact.id  : null;
            this.filter.role     = this.role;

            this.loading = true;
            Site.sites(this.filter, (data) => {
                this.sites = data;
                this.companies = [];
                this.sites.forEach(site => {
                    if (site.maintenanceCompany && !this.companies.find(c => c === site.maintenanceCompany)) {
                        this.companies.push(site.maintenanceCompany);
                    }

                    if (site.escCompany && !this.companies.find(c => c === site.escCompany)) {
                        this.companies.push(site.escCompany);
                    }

                    if (site.zusCompany && !this.companies.find(c => c === site.zusCompany)) {
                        this.companies.push(site.zusCompany);
                    }
                });

                this.companies.sort();
                this.companies.unshift(ALL_COMPANIES);
                this.companyFilter = this.companies[0];

                this.loading = false;

                if (callback) {
                    callback();
                }

                this.onFilter();
            });
        },

        loadContactAssignments () {
            this.contactUnits = [];
            if (!this.contact) {
                if (!this.filter.customer) {
                    this.load();
                }

                this.onFilter();
                return;
            }

            Site.sitesByContact(this.contact.id, (data) => {
                this.contactUnits = data;

                if (!this.filter.customer) {
                    this.load(() => {
                        this.sites.forEach(site => {
                            site.checked = true;
                        })
                    });

                    return;
                }

                this.sites.forEach(site => {
                    site.checked = this.isSelected(site);
                })

                this.onFilter();
            });
        },

        onSite (site) {
            if (site) {
                this.$emit("site", site)
            }
        },

        onEdit (site) {
            this.edit = site;
            if (site) {
                this.$emit("click", site)
            }
        },

        onNewUnit () {
            Site.create(this.customer.id).then (unit => {
                this.sites.unshift(unit);
                this.$emit("new-site", unit)
                this.$nextTick(() => {
                    this.onFilter();
                });
            })
        },

        onBulkEdit () {
            this.$emit ("bulk-edit", this.$refs.iterator.filteredItems) ;
        },

        onFilterChanged () {
            // Reload sites from API with updated filter
            this.load();
        },

        onFilter () {
            if (!this.sites) {
                return false;
            }

            this.filteredUnits = this.sites.filter (unit => {
                // TODO: Currently hiding all sites for inactive contracts.
                
                // If we have visible contracts filter and no contract is selected
                if (this.visibleContracts !== null && !this.contract) {
                    // If no contracts are visible, show no sites
                    if (this.visibleContracts.length === 0) {
                        return false;
                    }
                    // Only show sites for visible (active) contracts
                    const matchesVisibleContract = this.visibleContracts.some(contract => 
                        contract.id === unit.contractMntId || 
                        contract.id === unit.contractEscId || 
                        contract.id === unit.contractLimId || 
                        contract.id === unit.contractZusId
                    );
                    if (!matchesVisibleContract) {
                        return false;
                    }
                }

                if (this.contact && (Contact.isGlobal(this.contact) || Contact.isGlobalCustomer(this.contact))) {
                    return this.filterUnit(unit);
                }

                if (!this.isItemSelected || this.assignUnitMode) {
                    return this.filterUnit(unit);
                }

                if (this.isContract(unit)) {
                    return this.filterUnit(unit);
                }

                if (this.isContact(unit)) {
                    return this.filterUnit(unit);
                }

                if (this.contract || this.contact) {
                    return false;
                }

                if (!this.filterCompany(unit)) {
                    return false;
                }

                return this.filter.orphan && !Site.isLiftmanagement(unit);
            });
        },

        onContractHistory (unit, typeId) {
            Contract.unit.history(unit.id, typeId).then(data => {
                this.history.unit = unit;
                this.history.data = data;
                this.history.show = true;
            });
        },

        filterCompany (unit) {
            if (this.companyFilter !== ALL_COMPANIES) {
                if (this.companyFilter !== unit.maintenanceCompany && this.companyFilter !== unit.escCompany && this.companyFilter !== unit.zusCompany) {
                    return false;
                }
            }

            return true;
        },

        filterUnit (unit) {
            const lmActive = Site.isLiftmanagement(unit);
            if (!this.filterCompany(unit)) {
                return false;
            }

            if (this.filter.terminate && !unit.limTerminate) {
                return false;
            }

            if (this.filter.active && lmActive) {
                return true;
            }

            if (this.filter.inactive && unit.status && unit.status.id !== 1) {
                return true;
            }

            if (this.filter.orphan && !lmActive) {
                return true;
            }

            return false;

            /*
            if ((this.filter.active && !this.filter.inactive) || (!this.filter.active && this.filter.inactive))  {
                if (this.filter.active && unit.status && unit.status.id > 1) {
                    console.log("yyy 0", unit.status)
                    return false;
                }

                if (this.filter.inactive && unit.status && unit.status.id === 1) {
                    console.log("yyy 1")
                    return false;
                }
            }

            if (!this.filter.orphan && !Site.isLiftmanagement(unit)) {
                console.log("yyy 2")
                return false;
            }

            if (this.filter.orphan &&  Site.isLiftmanagement(unit)) {
                console.log("yyy 3")
                return false;
            }

            return true;

             */
        },

        onAssign (unit) {
            if (this.contract) {
                Contract.assign(this.contract, unit).then(() => {
                    Core.message.hint(this, this.$t("unit.message.assigned", [ unit.fabricNo ]));
                    this.refreshContract(unit, true);
                })
            }

            if (this.contact) {
                Contact.assign(this.contact, unit).then(() => {
                    Core.message.hint(this, this.$t("unit.message.assigned", [ unit.fabricNo ]));
                    this.refreshContact(unit, true);
                });
            }
        },

        onDissolve (unit) {
            if ((this.contract)) {
                Contract.dissolve(this.contract, unit.id).then(() => {
                    Core.message.hint(this, this.$t("unit.message.dissolved", [ unit.fabricNo ]));
                    this.refreshContract(unit, false);
                });
            }

            if (this.contact) {
                Contact.dissolve(this.contact, unit.id).then(() => {
                    Core.message.hint(this, this.$t("unit.message.dissolved", [ unit.fabricNo ]));
                    this.refreshContact(unit, false);
                });
            }
        },

        onStartAssingMode () {
            this.$store.dispatch("setAssignUnitMode", true);
            this.onFilter();
        },

        onEndAssingMode () {
            this.$store.dispatch("setAssignUnitMode", false);
            this.onFilter();
        },

        isContract (unit) {
            if (!this.contract) {
                return false;
            }

            return Contract.isAssigned(this.contract, unit);
        },

        isContact (unit) {
            if (!this.contact) {
                return false;
            }

            return !!this.contactUnits.find(contactunit => unit.id === contactunit.id);
        },

        isSelected (unit) {
            let selected = !!(this.contact || this.contract);

            if (!selected) {
                return false;
            }

            if (this.contract) {
                selected = this.isContract(unit);
            }

            if (this.contact) {
                selected = this.isContact(unit);
            }

            return selected;
        },

        match (item, text) {
            if (!text) {
                return true;
            }

            const upperCaseText = text.toUpperCase();
            return this.matchProperty(item.fabricNo, upperCaseText)
                || this.matchProperty(item.street, upperCaseText)
                || this.matchProperty(item.zip, upperCaseText)
                || this.matchProperty(item.city, upperCaseText)
                || this.matchProperty(item.ve, upperCaseText)
                || this.matchProperty(item.ve2, upperCaseText)
                || this.matchProperty(item.ve3, upperCaseText)
                || this.matchProperty(item.contracttype, upperCaseText)
                || this.matchProperty(item.maintenanceCompany, upperCaseText)
                || this.matchProperty(item.escCompany, upperCaseText)
                || this.matchProperty(item.zusCompany, upperCaseText)
            ;
        },

        matchProperty (property, text) {
            if (!property) {
                return null;
            }

            return property.toUpperCase().includes (text);
        },

        refreshContract (unit, value) {
            const site = this.sites.find (u => u.id === unit.id);
            site.checked = value;

            Contract.refresh(unit.id).then ((data) => {
                if (this.contract.type.id === Contract.enums.types.lim || this.contract.type.id === Contract.enums.types.dls) {
                    site.contractLimExpiration = data.contractLimExpiration;
                    site.contractLimId = data.contractLimId;
                    site.contractLimTypeId = data.contractLimTypeId;
                    site.limLgsPerMonth = data.limLgsPerMonth;
                    site.limPricePerMonth = data.limPricePerMonth;
                    return;
                }

                if (this.contract.type.id === Contract.enums.types.zus) {
                    site.contractZusId = data.contractZusId;
                    site.contractZusExpiration = data.contractZusExpiration;
                    site.zusCompany = data.zusCompany;
                    return;
                }

                site.contractMntExpiration = data.contractMntExpiration;
                site.contractMntFrequency = data.contractMntFrequency;
                site.contractMntId = data.contractMntId;
                site.contractMntServiceCompany = data.contractMntServiceCompany;
                site.maintenanceCompany = data.maintenanceCompany;
                site.maintenanceType = data.maintenanceType;
            }).catch(error => {
                console.log(error)
            });
        },

        refreshContact (unit, value) {
            this.contactUnits.push(unit)
            const u = this.filteredUnits.find (s => s.id === unit.id)
            u.checked = value;
        },


        isAssignedToContract (site) {
            if (!this.contract) {
                return false;
            }

            switch (this.contract.type.id) {
                case Contract.enums.types.lim:
                case Contract.enums.types.dls:
                    return !!site.contractLimId;
                case Contract.enums.types.mnt:
                    return !!site.contractMntId;
                case Contract.enums.types.esc:
                    return !!site.contractEscId;
                case Contract.enums.types.zus:
                    return !!site.contractZusId;
            }

            return false;
        }
    },
}
</script>

<style scoped>
</style>